import { render } from "./Scanner.vue?vue&type=template&id=2deefc61&scoped=true"
import script from "./Scanner.vue?vue&type=script&lang=js"
export * from "./Scanner.vue?vue&type=script&lang=js"

import "./Scanner.vue?vue&type=style&index=0&id=2deefc61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2deefc61"]])

export default __exports__